export default {"src":"/_next/static/media/master_card_icon.6d25791c.svg","height":128,"width":156,"blurWidth":0,"blurHeight":0};